<a *ngIf="bettingGame && !noLink" [href]="bettingGame?.description.web_url" class="link-element">
  <img [src]="bettingGame?.description.cta_banner" alt="Tippspiel">
</a>

<button *ngIf="bettingGame && noLink" class="link-element" (click)="bettingGameClick.emit()">
  <img [src]="bettingGame?.description.cta_banner" alt="Tippspiel">
</button>
